module.exports = __webpack_public_path__ + "img/select-dark-02.daebd28a.png";